import { useId } from "react";
import type { KioskOperationMode } from "../utils/kioskOperation";
import style from "../style/screens/KioskV2.module.css";

export default function KioskOperationModeInput({ value, onChange, disabled = false }: {
    value: KioskOperationMode | null;
    onChange: (mode: KioskOperationMode) => void;
    disabled?: boolean;
}) {
    const name = useId();
    return (
        <fieldset className={style["operation-mode"]} disabled={disabled}>
            <legend>운영 방식</legend>
            <div className={style["operation-mode-options"]}>
                <label>
                    <input type="radio" name={name} value="DONATE_AND_DEPOSIT"
                        checked={value === "DONATE_AND_DEPOSIT"} onChange={() => onChange("DONATE_AND_DEPOSIT")} />
                    <span>기부 + 적립 <small>기본값</small></span>
                </label>
                <label>
                    <input type="radio" name={name} value="DONATE_ONLY"
                        checked={value === "DONATE_ONLY"} onChange={() => onChange("DONATE_ONLY")} />
                    <span>기부만</span>
                </label>
            </div>
            <p>변경한 운영 방식은 다음 이용부터 적용됩니다. 이미 시작한 이용은 기존 방식으로 마무리됩니다.</p>
        </fieldset>
    );
}
